import { render, staticRenderFns } from "./KigeWrapper.vue?vue&type=template&id=7ae7bfcc&"
import script from "./KigeWrapper.vue?vue&type=script&lang=js&"
export * from "./KigeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports